import { render } from "./BuildTable.vue?vue&type=template&id=1f86bcf8"
import script from "./BuildTable.vue?vue&type=script&lang=js"
export * from "./BuildTable.vue?vue&type=script&lang=js"

import "./BuildTable.vue?vue&type=style&index=0&id=1f86bcf8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__